import React from 'react';
import { Grid, Typography } from '@mui/material';
import CategoryListSkeleton from 'sharedComponents/Skeleton/CategoryListSkeleton';
import { SparkButton } from 'sharedComponents/UI';
import { useGetCategories } from 'hooks/Categories';

type FilterCategoriesProps = {
  filterButtonClick: (value: string) => void;
  isFilterButtonActive: (value: string) => boolean;
};

function FilterCategories({
  filterButtonClick,
  isFilterButtonActive,
}: FilterCategoriesProps) {
  const { dropdownOptions, isLoading: isLoadingCategories } =
    useGetCategories();
  return (
    <Grid
      container
      item
      md={12}
      gap={1}
      sx={{ overflowX: 'auto' }}
      flexWrap='nowrap'
    >
      {isLoadingCategories ? (
        <CategoryListSkeleton />
      ) : (
        <>
          {[{ label: 'All', value: 'all' }, ...dropdownOptions].map(
            (option) => (
              <Grid item flex={1}>
                <SparkButton
                  key={option.value}
                  variant='contained'
                  title={option.label}
                  fullWidth={true}
                  sx={{
                    height: '40px',
                    minWidth: '150px',
                    borderRadius: '6px',
                    padding: '15px',
                    background: isFilterButtonActive(option.value as string)
                      ? '#6267AC'
                      : '#ffffff',
                    border: '1px solid #EEEEEE',
                    boxShadow: 'none',
                    fontSize: '16px',

                    '&:hover': {
                      border: isFilterButtonActive(option.value as string)
                        ? '1px solid #6267AC'
                        : '1px solid #EEEEEE',
                      boxShadow: 'none',

                      background: isFilterButtonActive(option.value as string)
                        ? '#6267AC'
                        : '#ffffff',
                    },
                  }}
                  onClick={() => filterButtonClick(option.value as string)}
                >
                  <Typography
                    fontFamily='Mont-semibold'
                    variant='body2'
                    textTransform='capitalize'
                    noWrap={true}
                    sx={{
                      color: isFilterButtonActive(option.value as string)
                        ? '#ffffff'
                        : '#000000',

                      '&:hover': {
                        color: isFilterButtonActive(option.value as string)
                          ? '#ffffff'
                          : '#000000',
                      },
                    }}
                  >
                    {option.label}
                  </Typography>
                </SparkButton>
              </Grid>
            )
          )}
        </>
      )}
    </Grid>
  );
}

export default FilterCategories;
